<template>
	<div name="hres37u-popup-approve" id="hres37u-popup-approve" class="modal fade" role="dialog">
		<div class="modal-dialog modal-lg">
	    <div class="modal-content">
	      <div class="modal-header header-popup">
          <button type="button" class="close" data-dismiss="modal" ref="popupApproveModalButton">&times;</button>
          <h4 class="modal-title">{{ labels['HRES37UC2']['0'] }}</h4>
        </div>

        <div class="modal-body detail detail-responsive">	
        	<div class="detail detail-responsive">
						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES37UC2']['10'] }}</div>
						  <div class="detail-right">
						      <div class="detail-text width-70" id="coddesc_codempid" name="desc_codempid">{{ approve.codempid }} - {{ approve.desc_codempid }}</div>
						  </div>
						</div>

						<!-- Approvno -->
						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES37UC2']['20'] }}</div>
						  <div class="detail-right">
						      <div class="detail-text width-70" id="approvno" name="approvno">{{ approve.approvno }}</div>
						  </div>
						</div>

						<!-- Approve by -->
						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES37UC2']['30'] }}</div>
						  <div class="detail-right">
						      <div class="detail-text width-70" id="coddesc_codappr" name="desc_codappr">{{ approve.codappr }} - {{ approve.desc_codappr }}</div>
						  </div>
						</div>

						<!-- Dteappr -->
						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES37UC2']['40'] }}</div>
						  <div class="detail-right">
						    <div class="input-group width-70">
                  <hrms-datepicker  v-model="currentDate"
                                    v-show="false"
                                    v-validate="'required|date_format:DD/MM/YYYY'"
                                    data-vv-value-path="inputDate"
                                    name="currentDate"
                                    :has-error="errors.has('currentDate')" />

                  <hrms-datepicker  v-model="approve.dteappr"
                                    v-validate="'required|date_format:DD/MM/YYYY|after:currentDate'"
                                    data-vv-value-path="inputDate"
                                    name="dteappr"
                                    :has-error="errors.has('dteappr')" />
                  <div class="text-error" v-show="errors.has('dteappr')">{{errors.first('dteappr')}}</div>
						    </div>
						  </div>
						</div>

						<!-- status -->
						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES37UC2']['50'] }}</div>
						  <div class="detail-right">
						      <div class="detail-text width-70" id="status" name="status">{{ approve.status }}</div>
						  </div>
						</div>

						<!-- Remark -->
						<div class="clearfix detail-row">
						  <div class="detail-left label-left">{{ labels['HRES37UC2']['90'] }}</div>
						  <div class="detail-right">
							    <textarea class="textarea-text width-70" 
                            id="remark" 
                            name="remark" 
                            v-model="approve.remark"
                            maxlength="500" 
                            v-validate="'max:500'"
                            data-vv-name="remark"
                            :has-error="errors.has('remark')" ></textarea>
                  <div class="text-error" v-show="errors.has('remark')">{{errors.first('remark')}}</div>
                  <div class="remark-limit-character">{{ dispLimitLabel(500) }}</div> 
							</div>
						</div>

        	</div>			
        </div>

        <div class="modal-footer align-center border-color-skin">
          <button type="button" class="btn bg-green" @click="validatePopupApprove()" ><i class="fa fa-check-circle"></i> {{ labelsButton['approve'] }}</button>
        </div>

	    </div>
    </div>
	</div>
</template>

<script>
import moment from 'moment'
import { constLabels } from 'assets/js/constLabels.js'

export default {
  name: 'hres37u-popup-approve',
  data () {
    return {
      approve: {
        approvno: 0,
        chk_appr: '',
        numseq: '',
        dtereq: '',
        codempid: '',
        desc_codempid: '',
        dteappr: '',
        staappr: '',
        flgStaappr: '',
        status: '',
        remark: '',
        codappr: '',
        desc_codappr: '',
        flgwarn: ''
      },
      currentDate: moment().format('DD/MM/YYYY')
    }
  },
  watch: {
    indexSelected () {
      this.approve = {
        approvno: this.indexSelected.approvno,
        chk_appr: this.indexSelected.chk_appr,
        numseq: this.indexSelected.numseq,
        dtereq: this.indexSelected.dtereq,
        codempid: this.indexSelected.codempid,
        desc_codempid: this.indexSelected.desc_codempid,
        dteappr: moment().format('DD/MM/YYYY'),
        staappr: this.indexSelected.staappr,
        flgStaappr: this.indexSelected.flgStaappr,
        status: this.indexSelected.status,
        remark: '',
        codappr: this.codappr,
        desc_codappr: this.descCodappr,
        flgwarn: ''
      }
      this.$nextTick(function () {
        this.errors.clear()
      })
    }
  },
  props: [ 'labels', 'nowLang', 'postHres37uSendApprove', 'indexSelected', 'codappr', 'descCodappr', 'labelsButton' ],
  methods: {
    dispLimitLabel (limit) {
      return constLabels('limitTo') + ' ' + limit + ' ' + constLabels('characters')
    },
    validatePopupApprove () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.postHres37uSendApprove(this.sendApprove())
        }
      })
    },
    sendApprove () {
      return {
        approveParams: this.approve,
        referenceButton: this.$refs.popupApproveModalButton
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// popupApprove.vue?449b6a7e